/**
 * Egress policy header sanitization utilities.
 *
 * @module components/ui/egressPolicyUtils
 */

import type { EgressPolicyHeaderTransform } from '@/types';

/**
 * Sanitize headers before submission: strips incomplete secret refs
 * (empty secretId) by converting them back to plain-text headers.
 */
export function sanitizeEgressHeaders(
  headers: EgressPolicyHeaderTransform[] | undefined
): EgressPolicyHeaderTransform[] | undefined {
  if (!headers) return undefined;
  return headers
    .map((h) => {
      if (h.valueRef?.secretRef && !h.valueRef.secretRef.secretId) {
        // Incomplete secret ref — drop valueRef, fall back to plain value
        return { operation: h.operation, name: h.name, value: h.value ?? '' };
      }
      return h;
    })
    .filter((h) => {
      // Drop Set/Insert headers with no value source at all
      if (h.operation === 'Remove') return true;
      return !!(h.value || h.valueRef?.secretRef?.secretId);
    });
}
